<template>
  <Universal />
</template>

<script>
import Universal from "./Universal.vue";
export default {
  name: "Index",
  components: {
    Universal,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
